module.exports = __webpack_public_path__ + "img/pop-up-vn-35.e354889b.png";